// extracted by mini-css-extract-plugin
export default {"captchaContainer":"Captcha_captchaContainer__r40nW","modal":"Captcha_modal__t2Ona","modalContent":"Captcha_modalContent__Iq7Ce"};